import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  Alert,
  Spinner,
  Empty,
  Link,
} from '@printdeal/ui-library';

import QuoteListItem from './QuoteListItem';
import QuoteListPagination from './QuoteListPagination';
import { messages } from '../../../translations/quote';
import { useQuotes, useQuoteStatuses } from '../../hooks/useQuotes';
import { QUOTES_DEFAULTS } from '../../../../../services/quotes/QuotesService';

const QuoteList = () => {
  const intl = useIntl();
  const [currentPage, setCurrentPage] = useState<number>(1);

  const {
    status: quoteStatus,
    results: quotes,
    total: quoteTotal,
  } = useQuotes(currentPage);

  const {
    status: quoteStatusesStatus,
    results: quoteStatuses,
  } = useQuoteStatuses();

  if (quoteStatus === 'pending' || quoteStatusesStatus === 'pending') {
    return (
      <>
        <div className="pd-flex pd-h-[300px] pd-flex-row pd-items-center pd-justify-center">
          <Spinner size="lg" />
        </div>
        {
          quoteTotal > 0 && (
            <QuoteListPagination
              quotesPerPage={QUOTES_DEFAULTS.LIMIT}
              currentPage={currentPage}
              quoteTotal={quoteTotal}
              setCurrentPage={setCurrentPage}
            />
          )
        }
      </>
    );
  }

  if (quoteStatus === 'error' || quoteStatusesStatus === 'error') {
    return (
      <Alert variant="error">
        <FormattedMessage
          id="quotes.page.error.loading"
          defaultMessage="Something went wrong while fetching the quotes."
        />
      </Alert>
    );
  }

  if (!quotes || !quoteStatuses || quoteTotal === 0) {
    return (
      <Empty
        icon="search"
        title={intl.formatMessage(messages.quoteListErrorTitle)}
        description={intl.formatMessage(messages.quoteListErrorDescription, {
          contactLink: (
            <Link href={intl.formatMessage(messages.quoteContactUrl)}>
              contact
            </Link>
          ),
        })}
      />
    );
  }

  return (
    <>
      <ul className="pd-flex pd-flex-col pd-gap-4">
        {quotes.map((quote) => (
          <li key={quote.quoteId}>
            <QuoteListItem
              quote={quote}
              quoteStatuses={quoteStatuses}
            />
          </li>
        ))}
      </ul>

      <QuoteListPagination
        quotesPerPage={QUOTES_DEFAULTS.LIMIT}
        currentPage={currentPage}
        quoteTotal={quoteTotal}
        setCurrentPage={setCurrentPage}
      />
    </>
  );
};

export default QuoteList;
